import Icon from '../components/Icon.vue'

Icon.register({"gavel":{"width":512,"height":512,"paths":[{"d":"M505 199.4L482.3 176.7C473 167.4 457.8 167.4 448.4 176.7L442.7 182.4 329.6 69.3 335.3 63.6C344.6 54.2 344.6 39 335.3 29.7L312.6 7C303.3-2.3 288.1-2.3 278.7 7L154.2 131.5C144.9 140.9 144.9 156 154.2 165.4L176.9 188C186.2 197.4 201.4 197.4 210.8 188L216.5 182.4 256.1 222 175 303 169.4 297.4C156.9 284.9 136.6 284.9 124.1 297.4L9.4 412.1C-3.1 424.6-3.1 444.9 9.4 457.4L54.6 502.6C67.1 515.1 87.4 515.1 99.9 502.6L214.6 387.9C227.1 375.4 227.1 355.1 214.6 342.6L209 337 290 255.9 329.6 295.5 324 301.2C314.6 310.6 314.6 325.8 324 335.1L346.6 357.8C356 367.1 371.1 367.1 380.5 357.8L505 233.3C514.3 223.9 514.3 208.7 505 199.4z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/gavel.js
// module id = aVt3
// module chunks = 0